import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { DateTime } from 'luxon'

import { v4 as uniqid } from 'uuid'

import FormStatus from '@/Form/FormStatus'

import SubmitForm  from '@/Form/V2/SubmitForm'

import Radio from '@/Form/V2/Radio'
import Input from '@/Form/V2/Input'

import Loader from '@Pure/Loader'

import { num, capitalize, isTrue } from '@root/utility'

import FormsStore from '@Store/Forms'

const FORM_NAME = 'PrivateSaleRegistration';

export default function PrivateSaleRegistrationForm ({ data={ }, ...props })
{
	const { onRegister } = props;

	const [submit, setSubmit] = useState();
	const [status, setStatus] = useState({ });
	const [submitting, setSubmitting] = useState(false);

	const date_id = FormsStore.useState(s => s[FORM_NAME]?.date_id || '');

	useEffect(function ()
	{
		FormsStore.update(function (store)
		{
			store[FORM_NAME] ||= { };

			store[FORM_NAME].slug = data.slug;
		});
	},
	[data.slug]);

	const setPickedDate = useCallback(function (e)
	{
		const value = e?.target?.value;

		if (!value) return;

		FormsStore.update(function (store)
		{
			store[FORM_NAME] ||= { };

			store[FORM_NAME].date_id = value;
		});

		setStatus({ });
	},
	[]);

	const sendForm = useCallback(function (e)
	{
		if (submitting) return;

		FormsStore.update(function (store)
		{
			store[FORM_NAME]._submit_id = uniqid();
		});

		setSubmitting(true);
		setSubmit(uniqid());
	},
	[submitting]);

	const onError = useCallback(function (update)
	{
		setSubmit(undefined);
		setStatus(update);
		setSubmitting(false);
	},
	[]);

	const onSuccess = useCallback(function (update)
	{
		setSubmit(undefined);
		setStatus(update);
		setSubmitting(false);

		FormsStore.update(function (store)
		{
			store[FORM_NAME].date_id = '';
		});

		onRegister(update);
	},
	[onRegister]);

	const radios = useMemo(function ()
	{
		const NOW = DateTime.now();

		return data.dates.map(function (infos)
		{
			const time = DateTime.fromISO(infos.date).set(
			{
				hour: num(infos.start.h, 0),
				minute: num(infos.start.m, 0)
			})
			.setLocale('fr');

			const start_date = time
			.toFormat('cccc d MMMM \'de\' H\'h\'mm');

			const end_date = time.set(
			{
				hour: num(infos.end.h, 0),
				minute: num(infos.end.m, 0)
			})
			.toFormat('H\'h\'mm');

			const is__past = NOW > time.plus({ hours: -num(data.delta_h) });

			return (
				<Radio key={ infos.id }
					label={ capitalize(start_date + ' à ' + end_date) }
					name="date_id"
					value={ infos.id }
					checked={ date_id === infos.id }
					onChange={ setPickedDate }
					read-only={ is__past || isTrue(infos.__full) }
				/>
			);
		});
	},
	[date_id, data.dates, setPickedDate]);

	return (
		<>
			<h2 className="c-title c-title--v2 c-VP-registration__form-title">
				<span className="c-title__txt">
					Choisissez un des créneaux disponibles
				</span>
			</h2>

			<FormStatus statement="Le contrôle du nom du participant sera effectué à l’entrée de la vente privée." />

			<div className="c-VP-registration__form">

				<div className="u-full-width u-flex u-flex-wrap"
					style={ { gap: 30 } }>
					{ radios }
				</div>

				<div className="u-full-width u-flex u-flex-wrap u-margin-top-30"
					style={ { gap: 20 } }>

					<Input name="firstname"
						label="Prénom"
						form={ FORM_NAME }
						bemit={ ['50%'] }
						error={ status?.fields?.firstname?.error }
					/>

					<Input name="lastname"
						label="Nom"
						form={ FORM_NAME }
						bemit={ ['50%'] }
						error={ status?.fields?.lastname?.error }
					/>

				</div>

				<FormStatus { ...status } />

				<button type="button" className="c-btn c-btn--extra c-btn--primary
					u-margin-top-30"
					onClick={ sendForm }
					disabled={ submitting }>
					Confirmer mon inscription
					{
						submitting ?
						(
							<Loader bemit={ ['bg-primary', 'white'] }
								className="c-loader"
							/>
						)
						: undefined
					}
				</button>

				{
					submit ?
					(
						<SubmitForm form={ FORM_NAME } id={ submit }
							onError={ onError }
							onSuccess={ onSuccess }
							url="/private-sales/register"
						/>
					)
					: undefined
				}

			</div>
		</>
	);
}